import { Calendar, ArrowRight, TrendingUp, Clock, Zap, Sun, Droplet, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { latestArticles } from '../data/latestArticles.generated';

export function LatestArticles() {
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'Power Generation': return <Zap className="w-3 h-3" />;
      case 'Renewable Energy': return <Sun className="w-3 h-3" />;
      case 'Oil & Gas': return <Droplet className="w-3 h-3" />;
      default: return null;
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-end mb-12 gap-4">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Latest Energy Insights
            </h2>
            <p className="text-lg text-gray-600">
              Expert analysis and updates on Nigeria's energy sector
            </p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:flex items-center gap-2 bg-[#008751] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#006d41] transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
          >
            View All Articles
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer border border-gray-100 flex flex-col h-full"
            >
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <span className={`flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider ${article.category === 'Power Generation'
                    ? 'bg-[#E8F5E9] text-[#006b40]'
                    : article.category === 'Renewable Energy'
                      ? 'bg-yellow-50 text-[#8a5a00]'
                      : 'bg-blue-50 text-blue-700'
                    }`}>
                    {getCategoryIcon(article.category)}
                    {article.category}
                  </span>
                  {article.trending && (
                    <div className="flex items-center gap-1 text-[#C1272D] text-xs font-bold animate-pulse">
                      <TrendingUp className="w-3 h-3" />
                      <span>TRENDING</span>
                    </div>
                  )}
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#008751] transition-colors leading-tight line-clamp-2">
                  {article.title}
                </h3>

                <p className="text-gray-600 text-sm mb-6 line-clamp-3 leading-relaxed flex-1">
                  {article.excerpt}
                </p>

                <div className="mt-auto pt-4 border-t border-gray-100">
                  <div className="flex items-center justify-between text-xs text-gray-500 mb-4">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-3 h-3" />
                      <span>{article.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      <span>{article.readTime}</span>
                    </div>
                  </div>

                  <div className="w-full bg-gray-50 text-[#006b40] py-2.5 rounded-lg font-bold text-sm border border-gray-200 group-hover:bg-[#008751] group-hover:text-white group-hover:border-[#008751] transition-all flex items-center justify-center gap-2">
                    Read Article
                    <ArrowLeft className="w-4 h-4 rotate-180" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center sm:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 bg-[#008751] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#006d41] transition-all shadow-md w-full justify-center"
          >
            View All Articles
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
